
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bff-us",
      function () {
        return require("private-next-pages/bff-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bff-us"])
      });
    }
  